import { DomUtils } from './utils';

class MobileMenu {
    constructor() {
        this.DOM = {
            body: document.body,
            buttonMenu: document.querySelector('.button-menu'),
            headerNav: document.querySelector('.site-header nav'),
            dropdownMenuItemsMobile: document.querySelectorAll('.menu-fullscreen .menu-item-has-children')
        };

        this.viewportWidth = DomUtils.getViewportWidth();
        this.siteWidthMenuSwitch = 1000;

        this.setEventListeners();
    }

    setEventListeners() {
        if (this.viewportWidth > this.siteWidthMenuSwitch) {
            // this.DOM.buttonMenu.addEventListener('mouseover', () => this.showHeaderNav());
            // this.DOM.headerNav.addEventListener('mouseleave', () => this.hideHeaderNav());
        } else {
            this.DOM.buttonMenu.addEventListener('click', () => this.toggleMobileMenu());
        }

        // Mobile submenu toggles
        this.DOM.dropdownMenuItemsMobile.forEach((menuItem) => {
            const toggleArrow = menuItem.querySelector('.dropdown-arrow');
            toggleArrow.addEventListener('click', () => this.toggleSubMenu(menuItem));

            // Make links with href="#" or href="" or no href toggle submenu instead of navigating
            const linkWithEmptyHref = menuItem.querySelector('a[href="#"], a[href=""], a:not([href])');
            if (linkWithEmptyHref) {
                linkWithEmptyHref.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.toggleSubMenu(menuItem);
                });
            }
        });
    }

    toggleMobileMenu(force) {
        this.DOM.body.classList.toggle('menu-open', force);
    }

    toggleSubMenu(currentMenuItem) {
        const currentIsOpen = Boolean(currentMenuItem.classList.contains('open'));

        let alreadyOpened = false;
        this.DOM.dropdownMenuItemsMobile.forEach((subMenuItem) => {
            const isOpen = Boolean(subMenuItem.classList.contains('open'));
            if (isOpen) {
                subMenuItem.classList.remove('open');
                alreadyOpened = true;
            }
        });

        document.body.classList.toggle('mobile-submenu-open', !currentIsOpen);

        setTimeout(
            () => {
                if (!currentIsOpen) {
                    currentMenuItem.classList.add('open');
                }
            },
            alreadyOpened ? 600 : 0
        );
    }

    showHeaderNav() {
        this.DOM.body.classList.add('show-header-nav');
    }
    hideHeaderNav() {
        this.DOM.body.classList.remove('show-header-nav');
    }
}
new MobileMenu();
